/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const WB_SCAN_LOGS = gql`
    query Query(
        $criteria: filterByForWBExciseScanlogTable
        $skip: Int
        $limit: Int
        $sort: String
        $sortOrder: SortOrder
    ) {
        wbExciseScanlogTable(
            criteria: $criteria
            skip: $skip
            limit: $limit
            sort: $sort
            sortOrder: $sortOrder
        )
    }
`;
